<template>
  <div class="fee-management-wrapper py-4">
     <PageTitleBar
      parent="Institute Dashboard"
      title="Fee Management"
      icon="fas fa-coins fa-2x mb-2 text-warning"
    />
    <b-container fluid>

      <DashboardModal id="feeConfigModal" parent="Institute Dashboard › Fee Management" title="Configuration Settings"
        icon="fas fa-cogs fa-2x mb-2 text-primary" modal-class="usersListPendingFull fee-modal-single-scroll"
        show-institute-branding @close="closeConfig">
        <FeeConfig lazy ref="feeConfig" />
      </DashboardModal>

      <DashboardModal id="studentMappingModal" parent="Institute Dashboard › Fee Management"
        title="Student Category Mapping / Generate Ledger" icon="fas fa-users-cog fa-2x mb-2 text-success"
        show-institute-branding @close="closeStudentMapping">
        <StudentCategoryMapping lazy />
      </DashboardModal>

      <DashboardModal id="viewLedgerModal" title="View Ledger" parent="Institute Dashboard › Fee Management"
        icon="fas fa-file-invoice-dollar fa-2x mb-2 text-warning" show-institute-branding @close="closeViewLedger">
        <ViewLedger lazy />
      </DashboardModal>

      <DashboardModal id="billingCycleModal" title="Billing Cycle - Variable Fee Bill"
        parent="Institute Dashboard › Fee Management" icon="fas fa-calendar-alt fa-2x mb-2 text-secondary"
        modal-class="usersListPendingFull fee-modal-single-scroll"
        show-institute-branding @close="closeBillingCycle">
        <BillingCycle lazy />
      </DashboardModal>

      <DashboardModal id="feeCollectionModal" title="Collect Fee" parent="Institute Dashboard › Fee Management"
        icon="fas fa-hand-holding-usd fa-2x mb-2 text-danger" show-institute-branding @close="closeFeeCollection">
        <FeeCollection lazy />
      </DashboardModal>

      <DashboardModal id="studentsBillMappingModal" parent="Institute Dashboard › Fee Management"
        title="Students Bill Mapping" icon="fas fa-file-invoice-dollar fa-2x mb-2 text-info"
        modal-class="usersListPendingFull fee-modal-single-scroll"
        show-institute-branding @close="closeStudentsBillMapping">
        <StudentsBillMapping lazy />
      </DashboardModal>

      <DashboardModal id="studentBillAdjustmentsModal" parent="Institute Dashboard › Fee Management"
        title="Student Bill Adjustments" icon="fas fa-balance-scale fa-2x mb-2 text-primary"
        show-institute-branding @close="closeStudentBillAdjustments">
        <StudentBillAdjustments lazy />
      </DashboardModal>

      <DashboardModal id="feeReportModal" title="Fee Report" parent="Institute Dashboard › Fee Management"
        icon="fas fa-file-excel fa-2x mb-2 text-success" modal-class="usersListPendingFull fee-modal-single-scroll"
        show-institute-branding @close="closeFeeReport">
        <FeeReport lazy />
      </DashboardModal>

      <DashboardModal id="feeImportModal" title="Import Legacy Balances" parent="Institute Dashboard › Fee Management"
        icon="fas fa-file-import fa-2x mb-2 text-warning" modal-class="usersListPendingFull fee-modal-single-scroll"
        show-institute-branding @close="closeFeeImport">
        <FeeImport lazy @done="closeFeeImport" />
      </DashboardModal>

      <DashboardModal id="messBillImportModal" title="Import Mess Bill" parent="Institute Dashboard › Fee Management"
        icon="fas fa-utensils fa-2x mb-2 text-info" modal-class="usersListPendingFull fee-modal-single-scroll"
        show-institute-branding @close="closeMessBillImport">
        <MessBillImport lazy @done="closeMessBillImport" />
      </DashboardModal>

      <!-- ================= DEFAULT DASHBOARD CARDS ================= -->
      <b-row>
        <b-col v-for="card in cards" :key="card.title" cols="12" md="6" lg="3" class="mb-4">
          <b-card class="text-center fee-card h-100" @click="card.action" no-body>
            <div class="py-4 d-flex flex-column align-items-center">
              <i :class="card.icon + ' fa-3x mb-3 ' + card.color"></i>
              <h5 class="card-title mb-0">{{ card.title }}</h5>
            </div>
          </b-card>
        </b-col>
      </b-row>


    </b-container>
  </div>
</template>

<script>
import PageTitleBar from '@/components/templates/Dashboard/Institute/PageTitleBar.vue';
import FeeConfig from './configurationSettings.vue';
import StudentCategoryMapping from './studentCategoryMapping.vue';
import ViewLedger from '../fee_management/ViewLedger.vue';
import BillingCycle from './BillingCycle.vue';
import FeeCollection from '../fee_management/feeCollection.vue';
import StudentsBillMapping from './studentsBillMapping.vue';
import StudentBillAdjustments from './studentBillAdjustments.vue';
import FeeReport from './FeeReport.vue';
import FeeImport from './FeeImport.vue';
import MessBillImport from './MessBillImport.vue';
import DashboardModal from "@/components/templates/Dashboard/Institute/DashboardModal.vue"

export default {
  name: "feeManagementDashboard",

  components: {
    DashboardModal,
    FeeConfig,
    StudentCategoryMapping,
    ViewLedger,
    BillingCycle,
    FeeCollection,
    StudentsBillMapping,
    StudentBillAdjustments,
    FeeReport,
    FeeImport,
    MessBillImport,
    PageTitleBar
  },

  data() {
    return {
      cloudStorageRoot: null,
      cards: [
        {
          title: "Configuration Settings",
          icon: "fas fa-cogs",
          color: "text-primary",
          action: () => this.openConfig(),
        },
        {
          title: "Student Structure Mapping / Generate Ledger",
          icon: "fas fa-users-cog",
          color: "text-success",
          action: () => this.openStudentMapping(),
        },
        {
          title: "View Ledger",
          icon: "fas fa-file-invoice-dollar",
          color: "text-warning",
          action: () => this.openViewLedger(),
        },
        {
          title: "Create Bill",
          icon: "fas fa-calendar-alt",
          color: "text-secondary",
          action: () => this.openBillingCycle(),
        },
        {
          title: "Students Bill Mapping",
          icon: "fas fa-file-invoice-dollar",
          color: "text-info",
          action: () => this.openStudentsBillMapping(),
        },
        {
          title: "Student Bill Adjustments",
          icon: "fas fa-balance-scale",
          color: "text-primary",
          action: () => this.openStudentBillAdjustments(),
        },
        {
          title: "Collect Fee",
          icon: "fas fa-hand-holding-usd",
          color: "text-danger",
          action: () => this.openFeeCollection(),
        },
        {
          title: "Fee Report",
          icon: "fas fa-file-excel",
          color: "text-success",
          action: () => this.openFeeReport(),
        },
        {
          title: "Import Legacy Balances",
          icon: "fas fa-file-import",
          color: "text-warning",
          action: () => this.openFeeImport(),
        },
        {
          title: "Import Mess Bill",
          icon: "fas fa-utensils",
          color: "text-info",
          action: () => this.openMessBillImport(),
        },
      ],
    };
  },

  computed: {
    institute() {
      return this.$store.getters.getCurrentInstitution || {};
    },
  },

  created() {
    this.cloudStorageRoot = this.$store.getters.getAPIKey.userAttachments;
  },

  methods: {
    /* CONFIG */
    openConfig() { this.$bvModal.show("feeConfigModal"); },
    closeConfig() {
      if (this.$refs.feeConfig && this.$refs.feeConfig.goBack()) return;
      this.$bvModal.hide("feeConfigModal");
    },

    /* STUDENT CATEGORY MAPPING */
    openStudentMapping() { this.$bvModal.show("studentMappingModal"); },
    closeStudentMapping() { this.$bvModal.hide("studentMappingModal"); },

    /* VIEW LEDGER */
    openViewLedger() { this.$bvModal.show("viewLedgerModal"); },
    closeViewLedger() { this.$bvModal.hide("viewLedgerModal"); },

    /* BILLING CYCLE */
    openBillingCycle() { this.$bvModal.show("billingCycleModal"); },
    closeBillingCycle() { this.$bvModal.hide("billingCycleModal"); },

    /* FEE COLLECTION */
    openFeeCollection() { this.$bvModal.show("feeCollectionModal"); },
    closeFeeCollection() { this.$bvModal.hide("feeCollectionModal"); },

    /* STUDENTS BILL MAPPING */
    openStudentsBillMapping() { this.$bvModal.show("studentsBillMappingModal"); },
    closeStudentsBillMapping() { this.$bvModal.hide("studentsBillMappingModal"); },

    /* STUDENT BILL ADJUSTMENTS */
    openStudentBillAdjustments() { this.$bvModal.show("studentBillAdjustmentsModal"); },
    closeStudentBillAdjustments() { this.$bvModal.hide("studentBillAdjustmentsModal"); },

    /* FEE REPORT */
    openFeeReport() { this.$bvModal.show("feeReportModal"); },
    closeFeeReport() { this.$bvModal.hide("feeReportModal"); },

    /* IMPORT LEGACY BALANCES */
    openFeeImport() { this.$bvModal.show("feeImportModal"); },
    closeFeeImport() { this.$bvModal.hide("feeImportModal"); },

    /* IMPORT MESS BILL */
    openMessBillImport() { this.$bvModal.show("messBillImportModal"); },
    closeMessBillImport() { this.$bvModal.hide("messBillImportModal"); },
  },
};
</script>

<style scoped>
.fee-management-wrapper {
  background: #f9f9fb;
  min-height: 100vh;
  padding-top: 1rem;
}

.page-header-row {
  padding: 0 16px;
}

.institute-branding {
  gap: 8px;
}

.institute-logo {
  height: 32px;
  width: 32px;
  object-fit: contain;
  border-radius: 4px;
}

.institute-name {
  font-weight: 600;
  color: #212529;
}

.fee-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  background: white;
  cursor: pointer;
}

.fee-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
}

.card-title {
  font-weight: 600;
  font-size: 1rem;
  transition: color 0.3s ease, text-decoration 0.3s ease;
}

.fee-card:hover .card-title {
  color: #0d6efd;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .text-right {
    text-align: center !important;
    margin-top: 1rem;
  }
}
</style>

<style>
/* App.vue gives every .table-responsive a fixed 400px height with its own
   vertical scroll; inside these full-screen modals the page already scrolls,
   so let tables grow and keep only horizontal scrolling. */
.fee-modal-single-scroll .table-responsive {
  height: auto !important;
  /* Not 'visible' - next to Bootstrap's overflow-x: auto the browser turns
     that into 'auto', and a wide table's horizontal scrollbar plus
     fractional row heights then adds a stray vertical scrollbar. The box is
     content height anyway, so hiding vertical overflow clips nothing. */
  overflow-y: hidden;
}

/* App.vue sizes the body as 100vh - 60px, but this header (with institute
   branding) is taller than 60px, so the whole modal overflowed and scrolled
   too. Let the body take whatever height the header leaves instead. */
.usersListPendingFull.fee-modal-single-scroll .modal-content {
  display: flex;
  flex-direction: column;
}

.usersListPendingFull.fee-modal-single-scroll .modal-body {
  height: auto;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
</style>
